import Head from "next/head";
import Grid from "@material-ui/core/Grid";
import Appbar from "../components/appBar";
import Footer from "../components/footer"; 
import WidgetWa from "../components/widgetWa";
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Typography from '../components/typography';
import Avatar from '@material-ui/core/Avatar';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useStyles from '../styles/customersStyle'; 

export default function Clientes() {

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <> 
      <Head>
        <title>Clientes</title>
        <link rel="icon" href="/favicon.ico" /> 
        <meta charSet="utf-8" />
        <meta itemProp="description" content="Conozca quienes son los clientes que depositan su confianza en Nosotros."/>
        <link rel="canonical" href="https://cidu.com.co/clientes" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>  
      <Grid>
        <Appbar/>
        <Grid className={classes.root} >
          <Grid item className={classes.backgrounclients}>
            <Container className={classes.Containertittle}>      
              <Grid container direction="column" justify="center" alignItems="stretch">
                <Grid container direction="row" justify="space-evenly" alignItems="stretch" className={classes.gridtittle}>    
                  <Grid item xs={12} md={7}> 
                    <Typography variant={matches ? "h3": "h2"} align="left" className={classes.tittleclients}>
                        CLIENTES
                    </Typography> 
                    <Typography variant="h6" align="left"  component="p"  className={classes.subtittleclients}>
                      <b>CONSULTORÍA DE INGENIERÍA & DESARROLLO URBANO S.A.S</b>, 
                      ajustado a sus valores corporativos, presta sus servicios 
                      a entidades estatales, privadas y mixtas, de ámbito nacional como internacional, así como a personas naturales, 
                      brindando así soluciones integrales mediante información confiable para decisiones efectivas.
                    </Typography> 
                  </Grid>
                  <Hidden smDown>
                    <Grid item 
                        container
                        xs={12} md={5}
                        justify="center"
                        alignItems="center">   
                        <Avatar alt="clientes"  variant="square" src={"/images/clients/peopleClients.png"} className={classes.tittleicon} imgProps={{ draggable: 'false' }}/>   
                    </Grid>
                  </Hidden>  
                </Grid>
                <Grid item
                    container
                    direction="row"
                    justify="space-evenly">
                    <Avatar alt="Arrow" src={"/images/clients/ArrowCircleWhite.svg"} className={classes.arrowicon} draggable='false'/>
                </Grid>  
              </Grid>
            </Container>
          </Grid>
          <Grid item className={classes.backgrounOurclients}>
            <Container maxWidth='xl' className={classes.ContainerOurclients}>        
              <Grid item container justify="center">
                <Typography variant="h4" marked="center" align="center"   className={classes.tittleOurclients}>
                    Nuestros Clientes
                </Typography>
              </Grid>
                    
              <Grid container direction="column" justify="space-evenly" alignItems="center">    
                <Grid container direction="row" justify="space-around" alignItems="flex-start">

                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-colpatria.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>  
                        CONSTRUCTORA COLPATRIA 
                      </Typography>
                  </Grid>

                  <Grid item 
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu} > 
                      <img alt="home Sentry" src={"/images/clients/Client-cusezar.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                          CUSEZAR 
                      </Typography>
                  </Grid>
    
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-enelcodensa.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                          ENEL-CODENZA
                      </Typography>
                  </Grid>
                </Grid>     

                <Grid container direction="row" justify="space-around" alignItems="flex-start">
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-tequendama.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                      MORTEROS TEQUENDAMA S.A.
                      </Typography>
                  </Grid>

                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-acueducto.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                      EAAB
                      </Typography>
                  </Grid>

                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-fecomar.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                      INVERSIONES SAMAR 
                      </Typography>
                  </Grid>
                </Grid> 

                <Grid container direction="row" justify="space-around" alignItems="stretch"> 
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-omegaa.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                          OMEGA ENERGY COLOMBIA
                      </Typography> 
                  </Grid>
              
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-mercurio.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                      CENTRO COMERCIAL MERCURIO
                      </Typography>
                  </Grid>

                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}>
                      <img alt="home Sentry" src={"/images/clients/Client-homecentry.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>  
                          HOME SENTRY  
                      </Typography>
                  </Grid>
                </Grid>   

                <Grid container direction="row" justify="space-around" alignItems="stretch"> 
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}>

                      <img alt="home Sentry" src={"/images/clients/Client-derechoydesarrollo.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                      DERECHO Y DESARROLLO URBANO S.A.S
                      </Typography>
                  </Grid> 
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}>  
                      <img alt="home Sentry" src={"/images/clients/Client-ipcom.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                      IPCOM COLOMBIA S.A.S
                      </Typography>
                  </Grid> 
                  <Grid item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      xs={12} sm={6} md={4} 
                      className={classes.clientcidu}> 
                      <img alt="home Sentry" src={"/images/clients/Client-urbana.svg"}  className={classes.avatarclients} draggable='false'/>  
                      <Typography variant="h6" align="center" className={classes.tittleOurclients}>  
                      URBANA ENGINEERING & SURVEY S.A.S
                      </Typography>  
                  </Grid>
                </Grid>  

                <Grid container direction="row" justify="center" alignItems="stretch">
                    <Grid item
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        xs={12} md={4} 
                        className={classes.clientcidu}> 
                        <img alt="home Sentry" src={"/images/clients/Client-callzila.svg"}  className={classes.avatarclients} draggable='false'/>  
                        <Typography variant="h6" align="center" className={classes.tittleOurclients}>
                        CALLZILLA
                        </Typography>
                    </Grid> 
                </Grid>  
              </Grid> 
            </Container>
          </Grid>
        </Grid>
        <Footer/>
      </Grid>
      <WidgetWa link={"https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!"}/>
    </>
  );
}
